import { TrashIcon } from "@snapchat/snap-design-system-icons";
import { type FC, useCallback } from "react";
import { Visible } from "../../common/components";
import { DisabledButtonToolipFix, ActionDisabledTooltip } from "../../common/components/ActionDisabledTooltip";
import { AccessContainer } from "../../common/containers/AccessContainer";
import { Flexbox } from "../../core/components";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../gql-generated/types";
import { type SourceModel } from "../models";
import { LensSourceInformation, LensSourceName, LensSourceTypeLabel } from "./EnabledLensSources.styles";
import { getLensSourceTypeLabel } from "./lensSourceTypeLabels";

interface LensSourcesListByTypeProps {
    lensSource: SourceModel;
    onDelete: (lensSource: SourceModel) => void;
    isFirst: boolean;
    type: LensSourceType;
}

export const LensSourcesListByType: FC<LensSourcesListByTypeProps> = ({ lensSource, onDelete, isFirst, type }) => {
    const { name } = lensSource;
    const handleDelete = useCallback(() => {
        onDelete(lensSource);
    }, [lensSource, onDelete]);
    return (
        <LensSourceInformation alignItems="center" justifyContent="space-between">
            <Flexbox flexDirection="column" flex="1">
                <Visible when={isFirst}>
                    <LensSourceTypeLabel>{getLensSourceTypeLabel(type)}</LensSourceTypeLabel>
                </Visible>
                <Flexbox justifyContent="space-between" alignItems="baseline">
                    <LensSourceName>{name}</LensSourceName>
                    <AccessContainer>
                        {({ permissions }) => (
                            <ActionDisabledTooltip
                                placement="left"
                                hasPermission={permissions?.updateLensSources ?? false}
                            >
                                <DisabledButtonToolipFix
                                    data-testid={`lens-source-remove-${type}`}
                                    shape="circle"
                                    onClick={handleDelete}
                                    isDisabled={!permissions.updateLensSources}
                                >
                                    <TrashIcon />
                                </DisabledButtonToolipFix>
                            </ActionDisabledTooltip>
                        )}
                    </AccessContainer>
                </Flexbox>
            </Flexbox>
        </LensSourceInformation>
    );
};
